import { render, staticRenderFns } from "./EdBadge.vue?vue&type=template&id=50f68d05&"
import script from "./EdBadge.vue?vue&type=script&lang=js&"
export * from "./EdBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports